import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";
import React from "react";

export const PersonIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue7fd'}</MuiIcon>
    );
}